<script setup lang="ts">
/**
 * The task drawer as a modal over the tmux view, which has no drawer of its
 * own: opened from the git panel's "Other tasks", so reading or adding one
 * does not throw the reader off the view they are working in. It is the same
 * selection as the board's drawer — `?task=` in the address, back closes it.
 */
import { useBoard } from "../stores/board.js";
import { closeTask } from "../lib/taskRoute.js";
import TaskDrawer from "./TaskDrawer.vue";

const board = useBoard();

function onKeydown(ev: KeyboardEvent): void {
  if (ev.key !== "Escape") return;
  ev.stopPropagation();
  closeTask();
}
</script>

<template>
  <Teleport to="body">
    <div
      class="modal-backdrop task-modal-backdrop"
      role="dialog"
      aria-modal="true"
      :aria-label="board.selected?.title || 'Task'"
      @pointerdown.self="closeTask"
      @keydown="onKeydown"
    >
      <TaskDrawer />
    </div>
  </Teleport>
</template>
